import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { reviewUtils } from "../../../utils/entityUtils";
import ReviewItem from "../ReviewItem/ReviewItem";
import classes from "./ChainReviews.module.css";

const ChainReviews = ({
  chainId,
  entityType,
  entityId,
  chainReviews = [],
  isLoading = false,
  onNavigateToReview,
  onVote,
}) => {
  const [displayedReviews, setDisplayedReviews] = useState([]);
  const isChain = !!chainId;
  const reviewHashTags = useSelector((state) => state.entities.reviewHashTags);

  useEffect(() => {
    // Filter and prepare chain reviews for display
    if (chainReviews && chainReviews.length > 0) {
      const preparedReviews = [...chainReviews];
      preparedReviews.forEach((review) => reviewUtils.prepareReview(review, reviewHashTags?.restaurantTags));
      setDisplayedReviews(preparedReviews);
    }
  }, [chainReviews, reviewHashTags]);

  // Don't render if not a chain or no reviews to show
  if (!isChain || (!isLoading && displayedReviews.length === 0)) {
    return null;
  }

  return (
    <div className={classes.container}>
      <h4 className={classes.header}>{t("reviews_fromOtherBranches")}</h4>

      {isLoading ? (
        <div className={classes.loadingContainer}>
          <div className={classes.spinner}></div>
        </div>
      ) : (
        <div className={classes.reviewsList}>
          {displayedReviews.map((chainReview, index) => (
            <div key={chainReview.id || index} className={classes.reviewItemWrapper}>
              <ReviewItem
                review={{ ...chainReview, branchName: chainReview.entity_name }}
                entityType={entityType}
                entityId={entityId}
                onOpenAddReviewModal={onNavigateToReview}
              />
              {chainReview.entity_name && (
                <p className={classes.branchName}>
                  {t("restaurants_chainReviews_from", {
                    source: chainReview.entity_name,
                  })}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChainReviews;
